var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"outlined":"","rules":_vm.rulesName,"label":_vm.labelName,"counter":"","maxlength":_vm.maxlength,"autofocus":_vm.autofocus},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})}
var staticRenderFns = []

export { render, staticRenderFns }